
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/flexbox",
      function () {
        return require("private-next-pages/system/flexbox.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/flexbox"])
      });
    }
  